// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3EZQw","itemTitle":"ClientEmergencyInfo_itemTitle__UQw31","itemText":"ClientEmergencyInfo_itemText__3cN_d"};